import { mapActions, mapMutations, mapState } from "vuex"
import Util from '../../util/funcoes';

export default {
  data() {
    return {
      isLoading: false
    }
  },

  created() {
    this.listar()
  },

  computed: {
    ...mapState('contratosRenovarStore', {
      contratosRenovar(state) { return state.listaContratosRenovar }
    }),

    tooltipQuantidadeContratosIsVisible() {
      return this.contratosRenovar.length > 0;
    },

    quantidadeContratos() {
      const quantidade = this.contratosRenovar.length
      
      switch (quantidade) {
        case 1:
          return 'Exibindo 1 contrato.'
        default:
          return `Exibindo ${quantidade} contratos.`
      }
    }
  },

  methods: {
    ...mapActions('contratosRenovarStore',[
      'recuperarContratosRenovar'
    ]),
    ...mapMutations('contratosRenovarStore',[
      'limparLista'
    ]),

    listar() {
      const payload = {
        dataInicio: Util.avançarPeriodoDaData(Util.stringParaData(Util.primeiroDiaMes()), 1),
        dataFim: Util.avançarPeriodoDaData(Util.stringParaData(Util.ultimoDiaMes()), 1) 
      }

      this.showLoading();
      this.limparLista();
      this.recuperarContratosRenovar(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },   

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },
  }
}